import { DataQualityGrade } from '@lune-climate/lune'
import { getDataQualityScoreColor } from '@lune-fe/lune-components-lib'
import { Text } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import { FC } from 'react'

const DataHealthByShipmentLegsChartLegend: FC = () => {
    const labels = [
        { label: 'A: Excellent', color: getDataQualityScoreColor(DataQualityGrade.A) },
        { label: 'B: Good', color: getDataQualityScoreColor(DataQualityGrade.B) },
        { label: 'C: Fair', color: getDataQualityScoreColor(DataQualityGrade.C) },
        { label: 'D: Poor', color: getDataQualityScoreColor(DataQualityGrade.D) },
    ]

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                mb: 2,
                flexWrap: 'wrap',
                gap: 1,
            }}
        >
            {labels.map(({ color, label }, index) => (
                <Box
                    key={index}
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        mr: 2,
                    }}
                >
                    <Box
                        sx={{
                            width: '20px',
                            height: '20px',
                            borderRadius: '100%',
                            backgroundColor: color,
                            mr: '12px',
                        }}
                    />
                    <Text variant={'body3'}>{label}</Text>
                </Box>
            ))}
        </Box>
    )
}

export default DataHealthByShipmentLegsChartLegend
